import { render } from "./AutoClipToggleSwitch.vue?vue&type=template&id=1d17d9bc&scoped=true&ts=true"
import script from "./AutoClipToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./AutoClipToggleSwitch.vue?vue&type=script&lang=ts"

import "./AutoClipToggleSwitch.vue?vue&type=style&index=0&id=1d17d9bc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d17d9bc"]])

export default __exports__